import { useEffect } from "react";
import * as React from "react";
import { Button, Typography } from "antd";
import { ExclamationCircleOutlined } from "@ant-design/icons";

const { Text, Title } = Typography;

const styles = {
  container: {
    display: "flex",
    flexDirection: "column" as const,
    alignItems: "center",
    justifyContent: "center",
    height: "100vh",
    width: "100vw",
    padding: "24px",
    boxSizing: "border-box" as const,
    textAlign: "center" as const,
    backgroundColor: "#fafafa",
  },
  content: {
    backgroundColor: "white",
    padding: "32px",
    borderRadius: "8px",
    boxShadow: "0 2px 8px rgba(0, 0, 0, 0.1)",
    maxWidth: "400px",
    width: "100%",
  },
  icon: {
    fontSize: "48px",
    color: "#faad14",
    marginBottom: "16px",
  },
  title: {
    marginBottom: "16px",
    color: "#262626",
  },
  message: {
    marginBottom: "24px",
    color: "#595959",
    lineHeight: "1.5",
  },
  buttonGroup: {
    display: "flex",
    gap: "12px",
    justifyContent: "center",
  },
};

const AlreadyExistsPopup: React.FC = () => {
  useEffect(() => {
    Office.onReady().then(() => {
      // Notify parent that the dialog is ready to receive messages
      Office.context.ui.messageParent("ready");
    });
  }, []);

  const handleOverwrite = () => {
    Office.context.ui.messageParent("overwrite");
  };

  const handleCancel = () => {
    Office.context.ui.messageParent("cancel");
  };

  return (
    <div style={styles.container}>
      <div style={styles.content}>
        <div style={styles.icon}>
          <ExclamationCircleOutlined />
        </div>

        <Title level={4} style={styles.title}>
          Data Already Exists
        </Title>

        <Text style={styles.message}>
          The data you're trying to upload already exists in the system. Would you like to overwrite the existing data
          or cancel this operation?
        </Text>

        <div style={styles.buttonGroup}>
          <Button type="primary" danger onClick={handleOverwrite} size="large">
            Overwrite
          </Button>
          <Button onClick={handleCancel} size="large">
            Cancel
          </Button>
        </div>
      </div>
    </div>
  );
};

const App: React.FC = () => {
  return <AlreadyExistsPopup />;
};

export default App;
